import Box from "@mui/material/Box";
import React from "react";
import { useForm } from "react-hook-form"
import { QRCode } from "react-qrcode-logo";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";

export const QrCodeGenerator = ({ currentUser }: any) => {
    const initialValues = {
        username: currentUser.username,
        password: ''
    }
    const { register, handleSubmit, watch } = useForm({
        defaultValues: initialValues
    });
    const values = watch();
    return (
        <form onSubmit={handleSubmit(() => {})}>
            <FdTextField
              autoFocus
              margin="dense"
              name="username"
              register={register}
              label="Username"
            />
            <FdTextField
              margin="dense"
              name="password"
              register={register}
              label="Password"
              type="password"
            />
            <Box
              id="loginCode"
              sx={{
                mt: 3,
                display: "flex",
                borderRadius: 6,
                justifyContent: "center",
                height: "180px",
              }}
            >
              {values.username && values.password && (
                <QRCode
                  value={`${values.username}\t${values.password}`}
                  ecLevel="M"
                  size={160}
                />
              )}
            </Box>
          </form>
    )
}